import { cva, VariantProps } from 'class-variance-authority';
import { HTMLAttributes } from 'react';
import { cn } from '~/helpers/utils';
import { useCampaign } from '~/layouts/CampaignContext';

export const containerVariants = cva('container', {
  variants: {
    state: {
      default: '',
      defaultLayoutFirst: 'relative z-10 default--first',
      defaultLargeFirst: 'relative z-10 default--large-first',
      imageLayoutFirst: 'relative z-10 image--first',
      toolLayout: 'max-w-[1620px]',
    },
  },
  defaultVariants: {
    state: 'default',
  },
});

interface ContainerProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof containerVariants> {
  compactView?: boolean;
  isCampaign?: boolean;
}

const Container = ({
  className,
  state,
  children,
  ...props
}: ContainerProps) => {
  const { campaign } = useCampaign();

  return (
    <div
      className={cn(
        !campaign?.isInternal && campaign?.campaignCode
          ? 'campaign-container' // Set to a simple container in case of loading a campaign
          : containerVariants({ state }),
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default Container;
